module.exports = __webpack_public_path__ + "media/images/favicon-cf582c49dd1286af8d11da2c763d594e.ico";